export enum TimeFormat {
	TWELVE_HOUR = '12h',
	TWENTY_FOUR_HOUR = '24h',
}
